import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CloseCircle } from '../../assets/icons/close-circle.svg';

/**
 * Modal Box function component
 * @param {any} param0 - The param0
 * @param {any} param0.title - The title prop
 * @param {any} param0.content - The content prop
 * @param {any} param0.closeModal - The closeModal prop
 * @param {any} param0.open - The open prop
 * @param {any} param0.header - The header prop
 * @param {any} param0.rightCorner - The rightCorner prop
 * @param {any} param0.notification - The notification prop
 * @param {any} param0.version - The version prop
 * @param {any} param0.position - The position prop
 * @param {any} param0.modalBoxAnimation - The modalBoxAnimation prop
 * @param {any} param0.fullHeightWidth - The fullHeightWidth prop
 */
function ModalBox({
  title,
  content,
  closeModal,
  open,
  header,
  rightCorner,
  notification,
  version,
  position,
  modalBoxAnimation,
  fullHeightWidth,
}: {
  title: string | null;
  content: JSX.Element | null;
  closeModal: () => void;
  open: boolean;
  header: boolean;
  rightCorner?: string;
  notification?: boolean;
  version?: string;
  modalBoxAnimation?:
    | 'modalAnimateToTop'
    | 'modalAnimateToLeft'
    | 'modalAnimateFromLeft'
    | 'modalAnimateFromRight';
  fullHeightWidth?: boolean;
  position?:
    | 'center'
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'top-left'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-right'
    | 'top-right'
    | 'bottom-right'
    | 'top-left'
    | 'bottom-left';
}) {
  const { i18n } = useTranslation();
  const reference = useRef<HTMLDivElement>(null);
  /**
   * Click the outside page function
   * @param {any} event - The event
   */
  const handleClickOutside = (event: React.MouseEvent) => {
    const brand = process.env.REACT_APP_BRANDING === 'voltie';
    if (reference.current === event.target) {
      if (!brand) {
        closeModal();
      }
    }
  };
  return open
    ? ReactDOM.createPortal(
        <div
          className={`modal-box-wrap open ${rightCorner} ${position}`}
          onClick={handleClickOutside}
          role="presentation"
          ref={reference}
          dir={i18n.dir()}>
          <div
            style={
              {
                '--modal-animation': modalBoxAnimation,
                ...(fullHeightWidth && {
                  height: '100%',
                  width: '100%',
                }),
              } as React.CSSProperties
            }
            className="modal-box-container">
            {header && (
              <div className={`modal-box-header-${version}`}>
                <div className="modal-box-title">
                  <span>{title}</span>
                </div>
                <div className="modal-box-icon" onClick={closeModal} role="presentation">
                  <CloseCircle />
                </div>
              </div>
            )}
            <div className="modal-box-body">
              {!header && !notification && (
                <div className="modal-box-icon" onClick={closeModal} role="presentation">
                  <CloseCircle />
                </div>
              )}
              {content}
            </div>
          </div>
        </div>,
        document.body,
      )
    : null;
}

ModalBox.defaultProps = {
  rightCorner: false,
  notification: false,
  version: 'v1',
  position: 'center',
  fullHeightWidth: false,
  modalBoxAnimation: '',
};
export default ModalBox;
